module.exports = __webpack_public_path__ + "static/media/bacem.9e8417cc.webp";